import { DocumentMapping } from "@/configuration/document-mappings/types";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import { getClassificationDisplay } from "@/src/lib/utils/classification";
import { Classification } from "@/src/models/constants/classifications";

export const MENT_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.REFERRAL]: {
    group: ConfigSubdomain.ENT_PARTNERS_MENT,
    classification: Classification.REFERRAL,
    displayName: getClassificationDisplay(Classification.REFERRAL, true),
    assignedTo: "Val_Carden, Jack",
    folder: "Referral Letters",
    workflowType: "Standard",
    inputDate: "",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateOfReferral }} ENT Referral",
    instructions: null,
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
    folderMapping: "Referral Letters",
  },
};
